export enum FeatureFlags {
  LANDING_PAGE_CK_EDITOR = 'portal-landing-page-ck-editor',
  EXTERNAL_DOCUMENT_EDITING = 'portal-external-document-editing',
  PERSONALIZED_DOCS = 'portal-personalized-docs',
}

export type LdOrgContext = {
  key: string
  [attribute: string]: unknown
}

export type Flags = { [key in FeatureFlags]: boolean }